import CustomSelect from 'components/ui/Editor/CustomSelect';
import FormikValidationError from 'components/ui/FormikErrors';
import TextInput from 'components/ui/TextInput';
import { FormikProps } from 'formik';
import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { useListEvalCriteriDetailsQuery } from 'redux/reducers/FeedbackEvaluation';
import { useListInternalUsersByTypeQuery } from 'redux/reducers/internal-user';
import { IEvaluationTraineeFormInput } from '../schema';
import { useListTrainingCourseQuery } from 'redux/reducers/training';

interface IAssignmentForm {
  formik: FormikProps<IEvaluationTraineeFormInput>;
  selectedData: any;
}

const AddEvaluationForm: FC<IAssignmentForm> = ({ formik, selectedData }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const { data: Details } = useListEvalCriteriDetailsQuery({ page, pageSize });

  const EvaluationTypeOption = [
    {
      value: 1,
      label: 'Pre Test'
    },
    {
      value: 2,
      label: 'Post Test'
    }
  ];

  const { id } = useParams();

  useEffect(() => {
    if (selectedData) {
      formik.setValues(selectedData);
    } else {
      formik.resetForm();
      formik.setFieldValue('routine_id', id);
    }
  }, [id, selectedData]);

  const { data: trainingData } = useListTrainingCourseQuery();

  return (
    <form>
      <div className="row">
        <CustomSelect
          options={EvaluationTypeOption}
          placeholder={'Select Assignment Type'}
          value={formik.values.evaluation_phase}
          onChange={(value: any) => formik.setFieldValue('evaluation_phase', value)}
          label={' Assignment'}
        />
        <FormikValidationError
          name="evaluation_phase"
          errors={formik.errors}
          touched={formik.touched}
        />
        <TextInput
          label="Title"
          name="title"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.title}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <TextInput
          label="Passing percentage"
          name="passing_percentage"
          type="text"
          onChange={formik.handleChange}
          value={formik.values.passing_percentage}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <TextInput
          label="start date time"
          name="start_date_time"
          type="date"
          onChange={formik.handleChange}
          value={formik.values.start_date_time}
          onBlur={formik.handleBlur}
          formik={formik}
        />
        <TextInput
          label="end date time"
          name="end_date_time"
          type="date"
          onChange={formik.handleChange}
          value={formik.values.end_date_time}
          onBlur={formik.handleBlur}
          formik={formik}
        />
      </div>
    </form>
  );
};

export default AddEvaluationForm;
